import { render, staticRenderFns } from "./EditWorkcenter.vue?vue&type=template&id=6db6423a&"
import script from "./EditWorkcenter.vue?vue&type=script&lang=js&"
export * from "./EditWorkcenter.vue?vue&type=script&lang=js&"
import style0 from "./EditWorkcenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports